import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_ALL_INVOICES,
  GET_ALL_INVOICES_SUCCESS,
  GET_ALL_INVOICES_FAILED,
  GET_INVOICES_WITH_ID,
  GET_INVOICES_WITH_ID_FAILED,
  GET_INVOICES_WITH_ID_SUCCESS,
  UPDATE_INVOICES,
  UPDATE_INVOICES_SUCCESS,
  UPDATE_INVOICES_FAILED,
  CREATE_INVOICES,
  CREATE_INVOICES_SUCCESS,
  CREATE_INVOICES_FAILED,
  GET_INVOICES_LOGS,
  GET_INVOICES_LOGS_SUCCESS,
  GET_INVOICES_LOGS_FAILED,
  REQUEST_TO_PAY,
  REQUEST_TO_PAY_FAILED,
  REQUEST_TO_PAY_SUCCESS
} from './constants';
import { Redirect } from 'react-router-dom';
import InvoicesRepository from 'client-sdk/src/Repository/invoices-repository';
import PaymentRepository from 'client-sdk/src/Repository/payment-repository';
import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotfication';

export function* getAllInvoices(actions: any): unknown {
  try {
    const {response, count} = yield InvoicesRepository.getInvoices(actions);
    yield put({
      type: GET_ALL_INVOICES_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_INVOICES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getInvoicesWithId(actions: any): unknown {
  try {
    const response = yield InvoicesRepository.getInvoiceWithId(actions);
    yield put({
      type: GET_INVOICES_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_INVOICES_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateInvoice(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield InvoicesRepository.updateInvoice(actions);
    yield put({
      type: UPDATE_INVOICES_SUCCESS,
    });
    yield put({
      type: GET_ALL_INVOICES,
      payload: {...pagination},
    });

    if (callback) {
      callback();
    }
  } catch (error) {
    yield put({
      type: UPDATE_INVOICES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createInvoice(actions: any): unknown {
  try {
    yield InvoicesRepository.createInvoice(actions);
    yield put({
      type: CREATE_INVOICES_SUCCESS,
    });
    handleNotfication('مرسوله مورد نظر شمابا موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_INVOICES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* requestToPay(actions: any): unknown {
  try {
    const response = yield PaymentRepository.requestToPay(actions);
    yield put({
      type: REQUEST_TO_PAY_SUCCESS,
      data : response.data
    });
    handleNotfication('در حال انتقال به صفحه پرداخت', 'success');
  } catch (error) {
    yield put({
      type: REQUEST_TO_PAY_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getLogs(actions: any): unknown {
  try {
    const response = yield InvoicesRepository.getLogs(actions);
    yield put({
      type: GET_INVOICES_LOGS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_INVOICES_LOGS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* invoiceSaga() {
  yield takeLatest(GET_ALL_INVOICES, getAllInvoices);
  yield takeLatest(GET_INVOICES_WITH_ID, getInvoicesWithId);
  yield takeLatest(UPDATE_INVOICES, updateInvoice);
  yield takeLatest(CREATE_INVOICES, createInvoice);
  yield takeLatest(REQUEST_TO_PAY, requestToPay);
  yield takeLatest(GET_INVOICES_LOGS, getLogs);
}
